<template>
  <h1 class="registration-title" :data-lang="lang"><slot></slot></h1>
</template>

<script>
import { getLangFromRoute } from '../../shared/languageHelpers';

export default {
  name: 'Title',
  data() {
    return { lang: 'de' };
  },
  created() {
    this.lang = getLangFromRoute(this.$route.path);
  },
};
</script>

<style scoped>
.registration-title {
  color: #2b4047;
  --reg-title-f-size: 25px;
  font-family: 'Foco', sans-serif;
  font-size: var(--reg-title-f-size);
  font-weight: bold;
}
@media (min-width: 375px) {
  .registration-title {
    --reg-title-f-size: 30px;
  }
}

@media (min-width: 1024px) {
  .registration-title {
    --reg-title-f-size: 45px;
  }
  .registration-title[data-lang='de'] {
    --reg-title-f-size: 35px;
  }
}
@media (min-width: 1280px) {
  .registration-title {
    --reg-title-f-size: 50px;
  }
  .registration-title[data-lang='de'] {
    --reg-title-f-size: 45px;
  }
}
</style>
